import { connect } from 'react-redux';
// eslint-disable-next-line import/no-named-as-default,import/no-named-as-default-member
import SettingsStock from './SettingsStock';
import { setSettingsPlantStorageTime, sendFileStockSettings, fetchStock } from '../../../store/actions/stock';
import { getSettingsPlant, getHolderSettingsPlant, setSettingsPlant, setSettingsTNPlant } from '../../../store/actions/settings';
import { setUserManual } from '../../../store/actions/userManual';
import { modalMessageOpen } from '../../../store/actions/modal';
import { modalErrorOpen } from '../../../store/actions/modalError';

const mapStateToProps = ({
  stockReducer,
  settingsReducer,
  userReducer,
  tabsReducer
}) => ({
  stockReducer,
  settingsReducer,
  userReducer,
  tabsReducer
});
const mapDispatchToProps = {
  getSettingsPlant,
  getHolderSettingsPlant,
  fetchStock,
  sendFileStockSettings,
  setSettingsPlant,
  setSettingsPlantStorageTime,
  setSettingsTNPlant,
  setUserManual,
  modalErrorOpen,
  modalMessageOpen
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SettingsStock);
